<template>
  <div id="videoplay">
    <h2 class="title">
      <a @click="back" class="prev"></a>
    </h2>
    <!--视频位置-->
    <div class="video" :style="'background-image: url(' + bgImage + ')'">
      <div id="videoPolyv"></div>
    </div>
    <!--播放组件-->
    <nav>
      <a @click="showList()"><img src="../../assets/icon/liveplay_icon_classlist.png" alt="">课程列表</a>
      <a @click="getPlayList(prevCourseId, prevVideoId)" :alt="prevCourseId + '-' + prevVideoId" :class="prevCourseId === '' || prevVideoId === '' ? 'disabled' : ''"></a>
      <a v-on:click="videoPlay()"><img :src="pause ? require('../../assets/icon/liveplay_icon_play.png') : require('../../assets/icon/liveplay_icon_pause.png')" :alt="currentCourseId + '-' + currentVideoId"></a>
      <a @click="getPlayList(nextCourseId, nextVideoId)" :alt="nextCourseId + '-' + nextVideoId" :class="nextCourseId === '' || nextVideoId === '' ? 'disabled' : ''"></a>
      <a @click="showWare()"><img src="../../assets/icon/liveplay_icon_pdfopen.png" alt="">课件下载</a>
    </nav>
    <!--课程列表-->
    <div class="course-list">
      <dl class="cc" v-for="(item, index) in courseList" v-bind:key="index">
        <dt :class="currentCourseId === item.course_id ? 'active' : ''" @click="showSection(item.course_id)">
          <h5>{{item.name}}</h5>
          <span class="arrow"></span>
        </dt>
        <video-list :class_id="classId" :course_id="item.course_id" :current_video_id="currentVideoId" v-on:listenVid="getPlayList"></video-list>
      </dl>
    </div>
    <current-class-all :class_id="classId" :course_id="currentCourseId" :current_video_id="currentVideoId" v-on:listenVid="getPlayList"  v-if="popupList" v-on:listenShow="hideList()"></current-class-all>
    <current-course-ware :class_id="classId" :course_id="currentCourseId" :current_video_id="currentVideoId" v-on:listenVid="getPlayList"  v-if="popupWare" v-on:listenShow="hideWare()"></current-course-ware>
  </div>
</template>

<script>
import videoList from './VideoPlayList'
import currentClassAll from '../share/popup/class/ClassAll'
import currentCourseWare from '../share/popup/class/CourseWare'
export default {
  name: 'VideoPlay',
  data () {
    return {
      classId: this.$route.query.class_id ? this.$route.query.class_id : 242,
      bgImage: '',
      courseList: {},
      videoList: [],
      player: null,
      currentCourseId: '', // 正在播放章节
      currentVideoId: '', // 正在播放视频ID
      currentVideoVid: '5111745181237048c371631853d0fc74_5', // 当前视频保利威视VID
      prevCourseId: '', // 上一个播放章节
      prevVideoId: '', // 上一个播放视频ID
      nextCourseId: '', // 下一个播放章节
      nextVideoId: '', // 下一个播放视频ID
      pause: true,
      popupList: false,
      popupWare: false,
      startTime: 0,
      scrollTop: undefined
    }
  },
  components: {
    videoList,
    currentClassAll,
    currentCourseWare
  },
  methods: {
    getCoursePurchased () {
      let data = {
        class_id: this.classId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_course_purchased',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            console.log('课程信息：')
            console.log(res)
            this.currentCourseId = res.data.data.video.course_id
            this.currentVideoId = res.data.data.video.video_id
            this.currentVideoVid = res.data.data.video.channel_vid
            this.prevCourseId = res.data.data.video.is_up_course
            this.prevVideoId = res.data.data.video.is_up_video
            this.nextCourseId = res.data.data.video.is_next_course
            this.nextVideoId = res.data.data.video.is_next_video
            this.bgImage = res.data.data.app_img_2
            // this.player.changeVid(this.currentVideoVid)
            this.$nextTick(() => { // 下一帧渲染
              this.getVideo()
            })
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'VideoPlay'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获得章节列表
    getCourseList () {
      let data = {
        class_id: this.classId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_list',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          if (res.data.errcode === 200) {
            this.courseList = res.data.data
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'VideoPlay'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获得上部播放按钮信息
    getPlayList (courseId, videoId) {
      if (courseId === '' || videoId === '') {
        event.preventDefault()
        return false
      }
      let data = {
        class_id: this.classId,
        course_id: courseId,
        video_id: videoId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_course_up_lower',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res) // 上线前删除
          if (res.data.errcode === 200) {
            this.currentCourseId = parseInt(res.data.data.course_id) // 后台传来的数据为字串
            this.currentVideoId = res.data.data.video_id
            this.currentVideoVid = res.data.data.channel_vid
            this.prevCourseId = res.data.data.is_up_course
            this.prevVideoId = res.data.data.is_up_video
            this.nextCourseId = res.data.data.is_next_course
            this.nextVideoId = res.data.data.is_next_video
            this.startTime = res.data.data.playDuration
            this.player.changeVid(this.currentVideoVid, this.startTime)
            this.pause = false // 显示暂停按钮
          } else if (res.data.errcode === -1) {
            this.$store.dispatch('alterName', '')
            this.$store.dispatch('alterNickname', '')
            this.$store.dispatch('alterPortrait', '')
            this.$store.dispatch('alterSchool', '')
            this.$store.dispatch('alterToken', '')
            this.$store.dispatch('alterUid', '')
            this.$store.dispatch('alterVipname', '')
            this.$store.dispatch('alterViptime', '')
            this.$router.push({name: 'PwdLogin', query: {backto: 'VideoPlay'}})
          } else {
            console.log(res.data.message)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    videoPlay () {
      if (this.pause) {
        this.player.j2s_resumeVideo() // 执行播放
        this.pause = false // 显示暂停按钮
      } else {
        this.player.j2s_pauseVideo() // 执行暂停
        this.pause = true // 显示播放按钮
      }
      // this.player.HTML5.togglePlay()
    },
    getVideo () {
      if (this.currentVideoVid) {
        this.player = window.polyvObject('#videoPolyv').videoPlayer({
          width: '7.5rem',
          // height: '4.24rem',
          height: '3.84rem',
          vid: this.currentVideoVid,
          session_id: this.$store.state.userid,
          watchStartTime: this.startTime,
          viewerInfo: {
            viewerId: this.$store.state.userid, // 用户id ，设置后会覆盖 statistics.session_id
            viewerName: this.$store.state.name, // 用户姓名, 设置后会覆盖 statistics.param2
            viewerAvatar: 'http://img.ysedu.com/1.png' // 用户头像
          }

          /*
          flashParams: {
            'wmode': 'window',
            'allowScriptAccess': 'always',
            'allowFullScreen': 'true'
          }
          */
          // forceH5: true
        })
      }
    },
    changePlay (Vid) {
      // alert(Vid)
      // return false
      this.player.changeVid(Vid)
    },
    // 章节展开效果 * 20191030
    showSection (courseId) {
      if (this.currentCourseId === courseId) {
        this.currentCourseId = 0
      } else {
        this.currentCourseId = courseId
      }
    },
    hideList () {
      this.popupList = false
    },
    showList () {
      this.popupList = true
    },
    hideWare () {
      this.popupWare = false
      document.body.classList.remove('popup')
      document.body.style.top = this.scrollTop
    },
    showWare () {
      this.scrollTop = document.scrollingElement.scrollTop
      this.popupWare = true
      document.body.classList.add('popup')
      document.body.style.top = `-${this.scrollTop}px`
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  },
  mounted () {
    this.getCoursePurchased()
    this.getCourseList()
  }
}
</script>

<style scoped lang="stylus">
  #videoplay
    .title
      position: absolute
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        z-index: 1000
        width: .8rem
        height: .8rem
        background-color: transparent
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #fff
          border-bottom: .03rem solid #fff
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    .video
      width: 7.5rem
      /*height: 4.24rem*/
      height: 3.84rem
      background: url(../../assets/img/liveplay_bg_video.png) no-repeat center
      -webkit-background-size: 100%
      background-size: 100%
    nav
      display: flex
      justify-content: space-around
      align-items: center
      /*background-color: #FAFAFA*/
      padding: .24rem 0
      a
        display: block
        text-align: center
        img
          display: block
          width: 100%
          height: 100%
        &:nth-of-type(1), &:nth-of-type(5)
          width: 1rem
          height: 1rem
          font-size: .22rem
          color: #999
          img
            width: .36rem
            height: .42rem
            margin: .14rem auto
        &:nth-of-type(2), &:nth-of-type(4)
          width: .96rem
          height: .96rem
        &:nth-of-type(2)
          background: url(../../assets/icon/liveplay_icon_previous.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          &:active
            background-image: url(../../assets/icon/liveplay_icon_previous1.png)
        &:nth-of-type(3)
          width: 1.28rem
          height: 1.28rem
        &:nth-of-type(4)
          background: url(../../assets/icon/liveplay_icon_next.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          &:active
            background-image: url(../../assets/icon/liveplay_icon_next1.png)
        &.disabled
          opacity: .2
    .course-list
      >>> dl
        dt
          position: relative
          display: flex
          justify-content: space-between
          align-items: center
          width: 7.5rem
          height: 1.24rem
          padding: 0 .3rem
          background-color: #F7F7F7
          border-bottom: .02rem solid #CFD1D4
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          h5
            font-size: .3rem
            color: #292929
            font-weight: 600
            &::before
              content: ""
              position: absolute
              top: .5rem
              left: 0
              display: inline-block
              width: .08rem
              height: .28rem
              background-color: #FF7052
          span.arrow
            &::before
              content: ""
              position: relative
              top: -.04rem
              right: .1rem
              display: inline-block
              width: .1rem
              height: .1rem
              border-left: .03rem solid #666
              border-bottom: .03rem solid #666
              -webkit-transform: rotate(-45deg)
              -moz-transform: rotate(-45deg)
              -ms-transform: rotate(-45deg)
              -o-transform: rotate(-45deg)
              transform: rotate(-45deg)
          &.active
            border: none
            span.arrow
              &::before
                top: 0
                -webkit-transform: rotate(135deg)
                -moz-transform: rotate(135deg)
                -ms-transform: rotate(135deg)
                -o-transform: rotate(135deg)
                transform: rotate(135deg)
          &.active + dd
            display: block
        dd
          display: none
          width: 7.5rem
          padding: 0 .4rem
          -webkit-box-sizing: border-box
          -moz-box-sizing: border-box
          box-sizing: border-box
          a
            position: relative
            display: flex
            justify-content: space-between
            align-items: center
            width: 100%
            height: 1.68rem
            border-bottom: .02rem solid #E1E1E1
            padding: .22rem 0
            -webkit-box-sizing: border-box
            -moz-box-sizing: border-box
            box-sizing: border-box
            &:last-child
              border: none
            .left
              display: block
              width: 5.6rem
              h6
                font-size: .32rem
                color: #292929
              .progress
                display: flex
                justify-content: space-between
                align-items: center
                margin-top: .2rem
                .bar
                  position: relative
                  width: 4.7rem
                  height: .12rem
                  background-color: #E5E7EB
                  -webkit-border-radius: .06rem
                  -moz-border-radius: .06rem
                  border-radius: .06rem
                  i
                    position: absolute
                    top: 0
                    left: 0
                    display: inline-block
                    width: 10%
                    height: 100%
                    background-color: #FF7052
                    -webkit-border-radius: .06rem
                    -moz-border-radius: .06rem
                    border-radius: .06rem
                span
                  display: inline-block
                  width: .96rem
                  height: .26rem
                  line-height: .26rem
                  font-size: .18rem
                  color: #8A88A1
                  text-align: center
              .livetime
                width: 100%
                line-height: .5rem
                margin-top: .05rem
                span
                  font-size: .2rem
                  color: #999
            .right
              position: relative
              display: block
              width: .84rem
              height: 1.22rem
              text-align: center
              img
                display: block
                width: .4rem
                height: .4rem
                margin: .25rem auto 0
            span.studied
              position: absolute
              top: 0
              right: 0
              display: block
              width: .84rem
              height: .32rem
              line-height: .32rem
              background-color: #3ED4B0
              font-size: .18rem
              color: #fff
              text-align: center
              -webkit-border-radius: 0 0 .04rem .04rem
              -moz-border-radius: 0 0 .04rem .04rem
              border-radius: 0 0 .04rem .04rem
            &.playing
              .left
                h6
                  color: #FF7052
                .progress
                  span
                    color: #FF7052
              .right
                color: #FF7052
</style>



// WEBPACK FOOTER //
// src/components/play/VideoPlay.vue